<div class="sla-container">
    <div class="sla-header">
        <div class="target">
            <h3>{{targetSLA}}%</h3>
            <span>Targeted</span>
        </div>

        <p-chart
            type="doughnut"
            [data]="chartData"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            class="sla-chart"
        ></p-chart>
    </div>
    <div class="sla-grid"
        [ngClass]="{ 'cols-3': isExpanded && slaAdherenceData.length > 10 }"
    >
        <div
            class="sla-item"
            *ngFor="let item of slaAdherenceData"
            matTooltipPosition="below"
            matTooltipClass="sla-item-tooltip"
            [matTooltip]="getSlaItemTooltip(item)"
        >
            <div class="label-row">
                <div class="label-container">
                    <span class="queue-name">{{ item.queueName }}</span>
                    <span class="sla-hours" *ngIf="showSlaInHours">({{ item.slaInHours }}hr)</span>
                </div>
                <span class="percent" [ngClass]="{ bad: item.slaAdherencePercentage < targetSLA, good: item.slaAdherencePercentage >= targetSLA }">
                    {{ isExpanded ? (item.slaAdherencePercentage | number: '1.0-1') + '%' : floorPercentage(item.slaAdherencePercentage) + '%' }}
                </span>
            </div>

            <p-progressBar
                [value]="item.slaAdherencePercentage"
                [showValue]="false"
                styleClass="progress-bar"
                [ngClass]="{ bad: item.slaAdherencePercentage < targetSLA, good: item.slaAdherencePercentage >= targetSLA }">
            </p-progressBar>
        </div>
    </div>
</div>
